module.exports = __webpack_public_path__ + "static/media/1007152.a13ff1fc.jpg";